import { useRef } from 'react';

export const usePageLoadLatch = (shouldLatch: boolean): boolean => {
    const hasLatchedRef = useRef(shouldLatch);

    if (shouldLatch) {
        hasLatchedRef.current = true;
    }

    return hasLatchedRef.current;
};
